/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuTool = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _join = _interopRequireDefault(require("../../../packages/join"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var BASE_CLASS_NAME = 'InovuaReactDataGrid__column-header__menu-tool';

var MenuTool = function (_React$Component) {
  (0, _inherits2.default)(MenuTool, _React$Component);

  var _super = _createSuper(MenuTool);

  function MenuTool(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MenuTool);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_unmounted", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMenuTool", function () {
      var domProps = {
        className: (0, _join.default)('', 'InovuaReactDataGrid__sort-icon--desc'),
        width: 14,
        height: 12
      };

      if (_this.props.renderMenuTool) {
        return _this.props.renderMenuTool(domProps);
      }

      return _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
        viewBox: "0 0 14 12"
      }), _react.default.createElement("g", {
        fillRule: "evenodd"
      }, _react.default.createElement("rect", {
        width: "14",
        height: "2",
        rx: "1"
      }), _react.default.createElement("rect", {
        width: "14",
        height: "2",
        y: "5",
        rx: "1"
      }), _react.default.createElement("rect", {
        width: "14",
        height: "2",
        y: "10",
        rx: "1"
      })));
    });
    _this.state = {
      keepVisible: false
    };
    _this.domRef = _react.default.createRef();
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseDown = _this.onMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.onHide = _this.onHide.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(MenuTool, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unmounted = true;
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      event.preventDefault();
      this.props.showContextMenu && this.props.showContextMenu(this, this.props.showOnHover ? this.onHide : null);

      if (this._unmounted) {
        return;
      }

      if (this.props.showOnHover && !this.state.keepVisible) {
        this.setState({
          keepVisible: true
        });
      }
    }
  }, {
    key: "onHide",
    value: function onHide() {
      if (this._unmounted) {
        return;
      }

      this.setState({
        keepVisible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = BASE_CLASS_NAME;
      var _this$props = this.props,
          showOnHover = _this$props.showOnHover,
          rtl = _this$props.rtl;

      if (showOnHover) {
        className += " ".concat(BASE_CLASS_NAME, "--show-on-hover");
      }

      if (!showOnHover || this.state.keepVisible) {
        className += " ".concat(BASE_CLASS_NAME, "--visible");
      }

      className += " ".concat(BASE_CLASS_NAME, "--direction-").concat(rtl ? 'rtl' : 'ltr');
      return _react.default.createElement("div", {
        className: className,
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        ref: this.domRef
      }, this.renderMenuTool());
    }
  }]);
  return MenuTool;
}(_react.default.Component);

exports.MenuTool = MenuTool;

var _default = function _default(props, cellInstance) {
  if (props.groupSpacerColumn) {
    return null;
  }

  if (!props.showColumnMenuTool) {
    return null;
  }

  return _react.default.createElement(MenuTool, {
    key: "menuTool",
    name: props.name,
    rtl: props.rtl,
    showOnHover: props.showColumnMenuToolOnHover,
    showContextMenu: cellInstance.showContextMenu,
    renderMenuTool: props.renderMenuTool
  });
};

exports.default = _default;